import {GroupedOption} from '@app/run-planning/model/option';

export enum FormFieldType {
  SECTION = 'section',
  TEXT = 'text',
  TEXTBOX = 'textbox',
  SELECT = 'select',
  FILESELECT = 'fileSelect',
  NUMBER = 'number',
  RADIO = 'radio',
  INTEGER = 'integer',
  CHECKBOX = 'checkbox',
  GENOME = 'genome',
  REFERENCE_FILE = 'referenceFile',
}

export interface IFormFieldSettings extends IReferenceFileFieldSettings, IGenomeFieldSettings {
  dependantFieldIds?: string[];
}

/* For IFormField with type === 'referenceFile' */
export interface IReferenceFileFieldSettings {
  referenceFileGenomeFilterFieldId?: string;
  referenceFileGenomeHashTableVersion?: string; // Not from GSS, computed on UI
  referenceFileTypeFilter?: string;
  isMultiSelect?: boolean; // Not from GSS, computed on UI
  maxSelection?: number;
  minSelection?: number;
}

/* For IFormField with type === 'genome' */
export interface IGenomeFieldSettings {
  hashTableVersion?: string;
}

export interface IFormFieldChoice {
  text: string;
  value: string;
  selected: boolean;
  availableWhen?: IFormFieldAvailableWhen[];
  disabled?: boolean;
  valid?: boolean;
}

export interface IFormFieldAvailableWhen {
  id: string;
  hasValue: string[];
}

// TODO value (for default value) is missing?
export interface IFormField {
  type: FormFieldType;
  id: string;
  label: string;
  mapping?: string;
  required?: boolean;
  hidden?: boolean;
  helpText?: string;
  choices?: IFormFieldChoice[];
  regex?: string;
  regexErrorMessage?: string;
  min?: number;
  max?: number;
  hasCustomOption?: boolean;
  groupedChoices?: GroupedOption[];
  disabled?: boolean;
  maxLength?: any;
  minLength?: any;
  updateRenderOnChange: boolean;
  settings: IFormFieldSettings;
  review?: string;
  genomeFilterGenomeId?: string; // Only for reference file fields with genome dependency
}
